import { render, staticRenderFns } from "./CollectionImageThumbnailIndex.vue?vue&type=template&id=de66287a&"
import script from "./CollectionImageThumbnailIndex.vue?vue&type=script&lang=js&"
export * from "./CollectionImageThumbnailIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports